import React, { useEffect } from 'react';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import { Button, Stack } from '@mui/material';
import { useAtom } from 'jotai';
import { selectedTurnBase } from '../../shared/selected.turn.base';
import { selectedTurnItem } from '../../shared/selected.turn.items';
import useHandleTurnBaseLogic from '../../Hooks/useHandleTurnBaseLogic';
import useCheckScreenWidth from 'Global/Hooks/useCheckScreenWidth';

const TurnBase = ({ turnBaseData }) => {
  const screenWidth = useCheckScreenWidth(); // 1024 for Desktop

  const serviceBased_label = FindLangKey(
    'general-public-service'
  );
  const professionBased_label = FindLangKey(
    'get-new-turn-label-profession'
  );

  const [turnBase, setTurnBase] = useAtom(selectedTurnBase);

  const [, setSelectedTurn] = useAtom(selectedTurnItem);

  useHandleTurnBaseLogic(
    setSelectedTurn,
    setTurnBase,
    turnBase,
    turnBaseData
  );

  // useEffect(() => {
  //   if (turnBase) {
  //     if (
  //       turnBase === 'service' &&
  //       turnBaseData?.serviceBased?.length === 1
  //     ) {
  //       setSelectedTurn(turnBaseData?.serviceBased[0]);
  //       return;
  //     }

  //     if (
  //       turnBase === 'speciality' &&
  //       turnBaseData?.specialityBased?.length === 1
  //     ) {
  //       setSelectedTurn(turnBaseData?.specialityBased[0]);
  //       return;
  //     }
  //   }
  // }, [turnBase]);

  return (
    <React.Fragment>
      <Stack
        gap=".5em"
        direction={
          screenWidth > 1024 ? 'row-reverse' : 'column'
        }
      >
        <Button
          variant="contained"
          onClick={() => {
            setTurnBase('service');
          }}
          sx={{
            color:
              turnBase === 'service'
                ? `${themeColors.ColorSecondary} !important`
                : `${themeColors.ColorPrimary} !important`,
            backgroundColor:
              turnBase === 'service'
                ? `${themeColors.ColorPrimary} !important`
                : ``,
          }}
          fullWidth
        >
          <p
            style={{
              textAlign: 'center',
            }}
          >
            {serviceBased_label}
          </p>
        </Button>

        <Button
          variant="contained"
          onClick={() => {
            setTurnBase('speciality');
          }}
          sx={{
            color:
              turnBase === 'speciality'
                ? `${themeColors.ColorSecondary} !important`
                : `${themeColors.ColorPrimary} !important`,
            backgroundColor:
              turnBase === 'speciality'
                ? `${themeColors.ColorPrimary} !important`
                : ``,
          }}
          fullWidth
        >
          <p
            style={{
              textAlign: 'center',
            }}
          >
            {professionBased_label}
          </p>
        </Button>
      </Stack>
    </React.Fragment>
  );
};

export default TurnBase;
